module.exports = __webpack_public_path__ + "media/images/icons/email-98b67078e8d1d9a4fb8b88d71c45bfd1.svg";